var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableOrder(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interrogation_8990312 1",
    clipPath: "url(#clip0_2425_117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.2969 12.05H0.703125C0.314812 12.05 0 12.3648 0 12.7531V15.7656C0 16.154 0.314812 16.4688 0.703125 16.4688H1.50628V23.2969C1.54087 24.2288 2.87827 24.2281 2.91253 23.2969V16.4687H21.0875V23.2969C21.1221 24.2288 22.4595 24.2281 22.4937 23.2969V16.4687H23.2969C23.6852 16.4687 24 16.1539 24 15.7656V12.7531C24 12.3648 23.6852 12.05 23.2969 12.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.23438 8.18437H15.7656C16.1539 8.18437 16.4687 7.86956 16.4687 7.48124C16.4687 5.25637 14.8343 3.40626 12.7031 3.06796V0.703118C12.6685 -0.228804 11.3311 -0.228101 11.2969 0.703118V3.06796C9.16569 3.40626 7.53125 5.25637 7.53125 7.48124C7.53125 7.86956 7.84606 8.18437 8.23438 8.18437Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2425_117"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableOrder);
export default __webpack_public_path__ + "static/media/Table_Order.7d2dc3a732225eb279fbc410504e397b.svg";
export { ForwardRef as ReactComponent };